export enum RoleType{
       CentralUser = 1,
       EIUser = 2,
       ExternalUser = 3,
       LocationUser = 4
   }